import React, { useState, useEffect } from 'react';

function Countdown({ targetDate, shortVersion }) {
  // פונקציה שמחשבת את הזמן שנותר עד לתאריך היעד
  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = new Date(targetDate) - now;
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  // מצב שמחזיק את הזמן שנותר
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  // אפקט שמעדכן את הזמן שנותר בכל שניה
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (shortVersion) {
    return (
      <span className="countdown text-fuchsia-500 notranslate">
        <span style={{ "--value": timeLeft.days || 0 }}></span>:
        <span style={{ "--value": timeLeft.hours || 0 }}></span>:
        <span style={{ "--value": timeLeft.minutes || 0 }}></span>:
        <span style={{ "--value": timeLeft.seconds || 0 }}></span>
      </span>
    );
  }

  return (
    <div className="grid grid-flow-col gap-5 text-center auto-cols-max notranslate">
      <div className="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
        <span className="countdown font-mono text-5xl">
          <span style={{ "--value": timeLeft.days || 0 }}></span>
        </span>
        days
      </div>
      <div className="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
        <span className="countdown font-mono text-5xl">
          <span style={{ "--value": timeLeft.hours || 0 }}></span>
        </span>
        hours
      </div>
      <div className="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
        <span className="countdown font-mono text-5xl">
          <span style={{ "--value": timeLeft.minutes || 0 }}></span>
        </span>
        min
      </div>
      <div className="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
        <span className="countdown font-mono text-5xl">
          <span style={{ "--value": timeLeft.seconds || 0 }}></span>
        </span>
        sec
      </div>
    </div>
  );
}

export default Countdown;
